import React, {useMemo} from "react";
import {Col, FormGroup} from "reactstrap";
import PropTypes from "prop-types";
import {FaAsterisk} from "react-icons/fa";
import Select from "react-select";
import HelpIcon from "../../HelpIcon/HelpIcon";

/** This component is wrapper around Select component of react select. With few extra features
 * like Label is form field required and help text.
 */

const SelectCreator = (props) => {
  const {
    label,
    value,
    options,
    onChange = () => {},
    large = false,
    colSize = "6",
    isRequired = false,
    help_text,
    isMulti = false,
    ...rest
  } = props;

  const selectedValue = useMemo(() => {
    if (isMulti) {
      return value?.length > 0
        ? options.filter((option) => value.includes(option.value))
        : [];
    }
    return value ? options.find((option) => option.value === value) : "";
  }, [value, options, isMulti]);

  const onChangeMethod = (event) => {
    onChange({
      target: {
        label: isMulti ? event.map((e) => e.label) : event?.label,
        value: isMulti ? event.map((e) => e.value) : event?.value,
        ...rest,
      },
    });
  };

  return (
    <Col md={large ? "12" : colSize}>
      <FormGroup>
        <div>
          {label && (
            <label className="form-control-label" htmlFor="input-name">
              {label}
            </label>
          )}
          {isRequired && (
            <FaAsterisk
              aria-hidden="true"
              aria-setsize={2}
              style={{
                fontSize: "8px",
                color: "red",
                padding: "0px 2px",
              }}
            />
          )}
          {help_text && <HelpIcon text={help_text} target={label} place="right" />}
        </div>
        <Select
          options={options}
          hasValue={true}
          value={selectedValue}
          isMulti={isMulti}
          closeMenuOnSelect={!isMulti}
          onChange={onChangeMethod}
          {...rest}
        />
      </FormGroup>
    </Col>
  );
};

SelectCreator.propTypes = {
  /** Label for form field */
  label: PropTypes.string,
  /** Value of selected option.
   * String for single select and Array for multi select
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]).isRequired,
  /** Options to be displayed in select dropdown */
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ).isRequired,
  /** Callback function which will be executed on selecting or clearing option */
  onChange: PropTypes.func,
  /** If this prop is set to true then this component will take 100% width of parent component */
  large: PropTypes.bool,
  /** This prop will be passed as colSize to reactstrap Col component */
  colSize: PropTypes.string,
  /** This prop determines wether form field is required */
  isRequired: PropTypes.bool,
  /** If value is passed for this prop this will be shown as tooltip when hovered on help icon */
  help_text: PropTypes.string,
  /** This prop determines wether select component allows multi select */
  isMulti: PropTypes.bool,
};

export default SelectCreator;
